export class LatLng extends google.maps.LatLng {}

export class Point extends google.maps.Point {}

export class Bounds extends google.maps.LatLngBounds {}

export type BoundingBox = [number, number, number, number];

export class LatLngBounds extends google.maps.LatLngBounds {}
